import React from 'react';
import gql from 'graphql-tag';
import GqlAutocomplete from './GqlAutocomplete';

const StaffGroupAutoComplete = ({
    category,
    className,
    name,
    clearOnSelect = true,
    multiple = true,
    members,
    ...props
}) => {
    return (
        <GqlAutocomplete
            className={className}
            readAllQuery={readAllStaffGroups}
            placeholder="Staff Group..."
            labelField="Title"
            multiple={multiple}
            name={name}
            clearOnSelect={clearOnSelect}
            {...props}
        />
    );
};

const readAllStaffGroups = gql`
    fragment GroupFragment on Group {
        ID
        Title
        Code
        Members {
            ID
            FirstName
            Surname
            Email
        }
    }

    query ReadGroups($contains: String) {
        readGroups(contains: $contains, parentGroupCode: "fm-user") {
            ...GroupFragment
        }
    }
`;

export default StaffGroupAutoComplete;
